export { default as ContentfulSlider } from './contentfulSlider'
export { default as ContentfulSlide } from './contentfulSlide'



// WEBPACK FOOTER //
// ./src/modules/contentful/slider/index.js